import { Component, ContentChildren, Input, OnDestroy, OnInit, QueryList } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RemoteControlService } from 'xsmodules/remote-control/services/remote-control.service';
import { RemoteControlTabService, TabSelectorState } from '../../services/rc-tab.service';
import { RcTabViewComponent } from '../rc-tab-view/rc-tab-view.component';

@Component({
  selector: 'app-rc-tab-selector',
  templateUrl: './rc-tab-selector.component.html',
  styleUrls: ['./rc-tab-selector.component.scss'],
})
export class RcTabSelectorComponent implements OnInit, OnDestroy {
  @Input('deviceId') public set setDeviceId(deviceId: string) {
    if (this.deviceId === deviceId) {
      return;
    }

    this.deviceId = deviceId;
    if (this.deviceId) {
      this.updateTabsState();
    }
  }

  public state: TabSelectorState;

  @ContentChildren(RcTabViewComponent) views: QueryList<RcTabViewComponent>;

  private deviceId: string;
  private destroyed$ = new Subject<boolean>();

  constructor(private rcService: RemoteControlService, private rcTabService: RemoteControlTabService) {}

  ngOnInit() {
    this.rcService.remoteControlStarted$.pipe(takeUntil(this.destroyed$)).subscribe(deviceId => {
      this.updateTabsState();
    });

    if (this.deviceId) {
      this.state = this.rcTabService.getState(this.deviceId);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public updateTabsState() {
    if (this.deviceId) {
      this.state = this.rcTabService.getState(this.deviceId);
      const viewsArray = this.views.toArray();
      for (let i = 0; i < viewsArray.length; i++) {
        if (this.state.tabs.length <= i) {
          this.state.addView(viewsArray[i]);
        } else {
          this.state.updateView(viewsArray[i], i);
        }
      }
    }
  }
}
